import { render, staticRenderFns } from "./PageAbout.vue?vue&type=template&id=4bac63f1&scoped=true&"
import script from "./PageAbout.vue?vue&type=script&lang=js&"
export * from "./PageAbout.vue?vue&type=script&lang=js&"
import style0 from "../../styles/content-page.css?vue&type=style&index=0&id=4bac63f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac63f1",
  null
  
)

export default component.exports